import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type NavRole = 'admin' | 'manager' | 'reviewer' | 'viewer';

type NavItem = {
    label: string;
    href: string;
    icon: string;
    query?: { [key: string]: string };
    badge?: string;
};

type NavGroup = {
    items: NavItem[];
};

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public get role(): NavRole {
        const role = String(this.service.auth.session?.role || '').toLowerCase();
        if (role === 'admin' || role === 'system') return 'admin';
        if (role === 'manager') return 'manager';
        if (role === 'reviewer') return 'reviewer';
        return 'viewer';
    }

    public get homeItem(): NavItem {
        if (this.role === 'admin') {
            return { label: '사용자/권한', href: '/members', icon: 'users' };
        }
        if (this.role === 'manager') {
            return { label: '자료 준비', href: '/literature', icon: 'library' };
        }
        if (this.role === 'reviewer') {
            return { label: '내 검수 작업', href: '/review', icon: 'review' };
        }
        return { label: '내 정보', href: '/mypage', icon: 'user' };
    }

    public get navGroups(): NavGroup[] {
        if (this.role === 'admin') return this.adminGroups();
        if (this.role === 'manager') return this.managerGroups();
        if (this.role === 'reviewer') return this.reviewerGroups();
        return this.viewerGroups();
    }

    public get utilityItems(): NavItem[] {
        return [
            { label: '내 정보', href: '/mypage', icon: 'user' },
        ];
    }

    private adminGroups(): NavGroup[] {
        return [
            {
                items: [
                    { label: '운영 현황', href: '/dashboard', icon: 'dashboard' },
                    { label: '사용자/권한', href: '/members', icon: 'users' },
                    { label: '운영 점검', href: '/harness', icon: 'settings' },
                    { label: '설정', href: '/settings', icon: 'settings' },
                ],
            },
        ];
    }

    private managerGroups(): NavGroup[] {
        return [
            {
                items: [
                    { label: '운영 현황', href: '/dashboard', icon: 'dashboard' },
                    { label: '자료 준비', href: '/literature', icon: 'library' },
                    { label: 'QA 작성', href: '/qa', icon: 'dataset' },
                    { label: '검수 현황', href: '/review', icon: 'review' },
                    { label: '평가/골든셋', href: '/eval', icon: 'award' },
                ],
            },
        ];
    }

    private reviewerGroups(): NavGroup[] {
        return [
            {
                items: [
                    { label: '내 검수 작업', href: '/review', icon: 'review' },
                ],
            },
        ];
    }

    private viewerGroups(): NavGroup[] {
        return [];
    }

    public isActiveItem(item: NavItem) {
        const pathMatched = item.href === '/' ? location.pathname === '/' : location.pathname.indexOf(item.href) === 0;
        if (!pathMatched) return false;

        const query = item.query || {};
        const queryKeys = Object.keys(query);
        const params = new URLSearchParams(location.search || '');
        if (!queryKeys.length) return true;

        return queryKeys.every(key => params.get(key) === String(query[key]));
    }

    public itemClass(item: NavItem) {
        if (this.isActiveItem(item)) {
            return 'group relative flex min-h-[40px] items-center gap-2.5 rounded-lg bg-white px-2 py-2 text-gray-950 transition';
        }
        return 'group relative flex min-h-[40px] items-center gap-2.5 rounded-lg px-2 py-2 text-gray-700 transition hover:bg-white hover:text-gray-950';
    }

    public iconClass(item: NavItem) {
        if (this.isActiveItem(item)) {
            return 'flex h-7 w-7 shrink-0 items-center justify-center text-gray-600 transition';
        }
        return 'flex h-7 w-7 shrink-0 items-center justify-center text-gray-500 transition group-hover:text-gray-700';
    }

    public badgeClass(item: NavItem) {
        return this.isActiveItem(item) ? 'rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700' : 'rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700';
    }

    public async logout(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        await this.service.request.post('/wiz/api/page.access/logout');
        this.service.auth.status = false;
        this.service.auth.session = {};
        location.href = "/access";
    }
}

export default ComponentNavSidebarComponent;